import React from 'react'
import PropTypes from 'prop-types'

const AdminValidate = props => (
  <div className={props.className}>
    {props.children}
    {!props.valid && <p className="help is-danger">{props.message}</p>}
  </div>
)

export default AdminValidate

AdminValidate.propTypes = {
  message: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  valid: PropTypes.bool.isRequired,
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/admin/AdminValidate.js